// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.leaflet-draw {
  display: none;
}

.leaflet-popup-close-button span {
  color: white;
}

.request-popup .leaflet-popup-content {
  margin: 0px;
}

.leaflet-popup-content p {
  margin: 8px;
}

.leaflet-draw .leaflet-control {
  display: none;
}
.leaflet-container {
  touch-action: auto; /* or 'manipulation' if needed */
  pointer-events: auto;
}
`, "",{"version":3,"sources":["webpack://./src/components/explorer/index.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;AACA;EACE,kBAAkB,EAAE,gCAAgC;EACpD,oBAAoB;AACtB","sourcesContent":[".leaflet-draw {\n  display: none;\n}\n\n.leaflet-popup-close-button span {\n  color: white;\n}\n\n.request-popup .leaflet-popup-content {\n  margin: 0px;\n}\n\n.leaflet-popup-content p {\n  margin: 8px;\n}\n\n.leaflet-draw .leaflet-control {\n  display: none;\n}\n.leaflet-container {\n  touch-action: auto; /* or 'manipulation' if needed */\n  pointer-events: auto;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
